export const SET_SKIPPED = "SET_SKIPPED";